module.exports = __webpack_public_path__ + "img/slide-nory.2fd020ccc8eb.png";